import React from 'react';

function AiChart({ chartData }) {
  const canvasRef = React.useRef(null);
  const chartRef = React.useRef(null);

  React.useEffect(() => {
    if (!canvasRef.current || !chartData || !window.Chart) return;

    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    const COLORS = ['#2563EB', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];
    const ctx = canvasRef.current.getContext('2d');

    chartRef.current = new window.Chart(ctx, {
      type: chartData.chartType,
      data: {
        labels: chartData.labels,
          datasets: chartData.datasets.map((d, i) => {
          const color = d.color || COLORS[i % COLORS.length];
          const isPie = chartData.chartType === 'pie' || chartData.chartType === 'doughnut';
          // d.backgroundColors가 있으면 그걸 우선 사용 (성별 같은 고정 색상)
          const pieColors = d.backgroundColors || d.data.map((_, idx) => COLORS[idx % COLORS.length]);
          return {
            label: d.label,
            data: d.data,
            backgroundColor: isPie
              ? pieColors
              : (chartData.chartType === 'line' ? color + '25' : color),
            borderColor: isPie
              ? pieColors
              : color,
            borderWidth: 2,
            borderRadius: chartData.chartType === 'bar' ? 6 : 0,
            fill: chartData.chartType === 'line',
            tension: 0.4,
            pointBackgroundColor: color,
            pointRadius: 4,
          };
        }),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top', labels: { font: { size: 12 } } },
        },
        scales: chartData.chartType === 'pie' ? {} : {
          y: {
            beginAtZero: true,
            grid: { color: '#F1F5F9' },
            ticks: {
              font: { size: 11 },
              callback: v => v >= 10000 ? (v / 10000).toFixed(0) + '만' : v,
            },
          },
          x: {
            grid: { display: false },
            ticks: { font: { size: 11 } },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [chartData]);

  return (
    <div style={{ background: '#fff', border: '1px solid #E2E8F0', borderRadius: 12, padding: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 500, color: '#1E293B', marginBottom: 12 }}>
        📊 {chartData.title}
      </div>
      <div style={{ height: 220, position: 'relative' }}>
        <canvas ref={canvasRef} />
      </div>
      {chartData.insight && (
        <div style={{ marginTop: 12, padding: '10px 12px', background: '#EFF6FF', borderRadius: 8, fontSize: 12, color: '#1D4ED8', lineHeight: 1.6 }}>
          💡 {chartData.insight}
        </div>
      )}
    </div>
  );
}

export default AiChart;